import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ProfessionSelectorComponent } from "../../features/profession/profession-selector/profession-selector.component";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { NewUiFormlyProfessionSelectorComponent } from "./new-ui-formly-profession-selector.component";

@Component({
  selector: "app-formly-profession-selector",
  templateUrl: "./formly-profession-selector.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProfessionSelectorComponent, FormsModule, ReactiveFormsModule, FormElementMapModule, TestIdDirective],
})
export class FormlyProfessionSelectorComponent extends NewUiFormlyProfessionSelectorComponent {}
